import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';
import { nanoid } from 'nanoid';
import React from 'react';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'row',
});

export const HeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
  fontSize: '1.125rem',
}));

type CustomFileInputButtonProps = Partial<React.InputHTMLAttributes<HTMLInputElement>> & {
  children: React.ReactNode;
};

export const FileInputButton = ({ children, ...inputProps }: CustomFileInputButtonProps) => {
  const id = React.useMemo(() => `file_input_${nanoid(3)}`, []);
  return (
    <Button component="label" htmlFor={id} disabled={inputProps?.disabled} size="medium">
      {children}
      <input type="file" hidden id={id} {...inputProps} />
    </Button>
  );
};
